import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import type { ProfileRestrictionReason } from '@wlb/shared/utils/profileVisibility';
import { BuddiesIcon, LockIcon, AlertCircleIcon } from '../../components/ui/icons';
import './profile.css';

interface ProfileRestrictedProps {
  reason: ProfileRestrictionReason;
}

const CONTENT = {
  private: { Icon: LockIcon, titleKey: 'profile.restricted.privateTitle', messageKey: 'profile.restricted.privateMessage' },
  buddiesOnly: { Icon: BuddiesIcon, titleKey: 'profile.restricted.buddiesTitle', messageKey: 'profile.restricted.buddiesMessage' },
  unavailable: { Icon: AlertCircleIcon, titleKey: 'profile.restricted.unavailableTitle', messageKey: 'profile.restricted.unavailableMessage' },
} as const;

export function ProfileRestricted({ reason }: ProfileRestrictedProps) {
  const { t } = useTranslation();
  const { Icon, titleKey, messageKey } = CONTENT[reason];

  return (
    <section className="profile-restricted">
      <span className="profile-restricted__icon">
        <Icon size={24} />
      </span>
      <h2 className="profile-restricted__title">{t(titleKey)}</h2>
      <p className="profile-restricted__message">{t(messageKey)}</p>
    </section>
  );
}
